import { Navigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuthStore } from '../store/authStore'

// Зеркало AuthGuard: тот не пускает гостей на приватные экраны, этот — уводит
// авторизованных с экранов входа и регистрации.
//
// Нужен из-за нативного возврата OAuth. В вебе бэкенд редиректит на корень, и
// маршрутизация сразу принимает верное решение; на нативе ссылка приходит
// событием appUrlOpen в уже отрисованное приложение, маршрут не меняется, и
// человек оставался на /login с рабочей сессией.
//
// Только /login и /register. НЕ /onboarding: туда useOnboardingGate штатно
// отправляет авторизованных, и защита тут закольцевала бы редиректы. И не
// /verify-email: по старой ссылке подтверждения может прийти человек с сессией.
export default function GuestOnly({ children }: { children: ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken)

  if (accessToken) return <Navigate to="/" replace />

  return children
}
